import forYouIcon from '@/assets/nav/for-you.png';
import sportIcon from '@/assets/nav/sport.png';
import cryptoIcon from '@/assets/nav/crypto.png';
import leaguesIcon from '@/assets/nav/leagues.png';
import inviteIcon from '@/assets/nav/invite.png';

/** PC / H5 顶栏频道导航图标 */
export const NAV_CHANNEL_ICONS = {
  forYou: forYouIcon,
  sport: sportIcon,
  crypto: cryptoIcon,
  leagues: leaguesIcon,
  invite: inviteIcon,
};
